import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ButtonTypes } from 'src/app/enums/button-type.enum';
import { Button } from 'src/app/models/button.model';
import { ModalContent } from 'src/app/models/modal-content.model';
import { AppState } from 'src/app/store';
import {
  ExchangeModel,
  selectExchangeModel
} from 'src/app/store/selectors/home/home.selectors';

@Component({
  selector: 'lns-exchange-modal',
  templateUrl: './exchange-modal.component.html',
  styleUrls: ['./exchange-modal.component.scss']
})
export class ExchangeModalComponent {
  @Input() modalContent!: ModalContent;
  @Output() closeModal = new EventEmitter();
  exchange$: Observable<ExchangeModel>;

  backButton: Button = {
    type: ButtonTypes.TransparentGrayText
  };

  confirmLinkButton: Button = {
    type: ButtonTypes.Primary,
    iml: '8',
    submitBtn: true
  };

  constructor(private store: Store<AppState>) {
    this.exchange$ = this.store.select(selectExchangeModel);
  }

  openLink(url: any): void {
    window.open(url, '_blank');
    this.closeModal.emit();
  }

  onBack(): void {
    this.closeModal.emit();
  }
}
